
import * as ol from 'openlayers';
import { Overlay } from './overlay';

class MeasureTooltip extends Overlay {
  constructor() { super(); }
  setHTMLElementStyle(): void {
    this.ele.style.position = 'relative';
    this.ele.style.background = 'rgb(23, 168, 162)';
    this.ele.style.borderRadius = '4px';
    this.ele.style.color = '#fff';
    this.ele.style.padding = '4px 30px 4px 8px';
    this.ele.style.whiteSpace = 'nowrap';
  }
}

class HelpTooltip extends Overlay {
  constructor() { super(); }
  setHTMLElementStyle(): void {
    this.ele.style.position = 'relative';
    this.ele.style.background = 'rgba(0, 0, 0, 0.5)';
    this.ele.style.borderRadius = '4px';
    this.ele.style.color = '#fff';
    this.ele.style.padding = '4px 8px';
    this.ele.style.opacity = '0.7';
    this.ele.style.whiteSpace = 'nowrap';
  }
}

function formatLength(line): string {
  const length = ol.Sphere.getLength(line, { projection: 'EPSG:4326' });
  let output;
  if (length > 100) {
    output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
  } else {
    output = (Math.round(length * 100) / 100) + ' ' + 'm';
  }
  return output;
}

function formatArea(polygon): string {
  const area = ol.Sphere.getArea(polygon, { projection: 'EPSG:4326' });
  return `æ»é¢ç§¯ï¼${area.toFixed(1)} å¹³æ¹ç±³<br/>çº¦ç­äºï¼${(area / 666.67).toFixed(2)}äº©`;
}

const _arr = new Array();

_arr['LineString'] = formatLength;

_arr['Polygon'] = formatArea;

function createSpan(deaw): HTMLElement {
  const span = document.createElement('sapn');
  span.innerHTML = ' X ';
  span.style.position = 'absolute';
  span.style.width = '14px';
  span.style.height = '14px';
  span.style.right = '4px';
  span.style.top = '4px';
  span.style.cursor = 'pointer';
  span.style.backgroundColor = '#fff';
  span.style.color = 'red';
  span.style.lineHeight = '14px';
  span.style.textAlign = 'center';
  span.addEventListener('click', (e: Event) => {
    deaw._clear();
    e.stopPropagation();
  }, false);
  return span;
}

function getVector(source: ol.source): ol.layer {
  return new ol.layer.Vector({
    source: source,
    style: new ol.style.Style({
      fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.4)' }),
      stroke: new ol.style.Stroke({
        color: '#ffcc33',
        width: 2
      }),
      image: new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({ color: '#ffcc33' })
      })
    })
  });
}

function addInteraction(
  darwType: string, source: ol.source,
  fillColor: string= 'rgba(255, 255, 255, 0.4)' ,
  strokeColor: string= 'rgba(255, 204, 51, 0.5)'
  ): ol.interaction.Draw {
  const draw = new ol.interaction.Draw({
    source: source,
    type: darwType,
    style: new ol.style.Style({
      fill: new ol.style.Fill({ color: fillColor }),
      stroke: new ol.style.Stroke({
        color: strokeColor,
        lineDash: [10, 10],
        width: 2
      }),
      image: new ol.style.Circle({
        radius: 5,
        stroke: new ol.style.Stroke({ color: 'rgba(255, 255, 255, 1)' }),
        fill: new ol.style.Fill({ color: 'rgba(200, 200, 200, 0.6)' })
      })
    })
  });
  return draw;
}


function addInteraction1(
  darwType: string,
  source: ol.source,
  fillColor: string= 'rgba(184, 233, 134, 0.56)',
  strokeColor: string= 'rgba(23, 168, 162, 0.56)'
  ): ol.interaction.Draw {
  const draw = new ol.interaction.Draw({
    source: source,
    type: darwType,
    style: new ol.style.Style({
      fill: new ol.style.Fill({ color: fillColor}),
      stroke: new ol.style.Stroke({
        color: strokeColor,
        lineDash: [10, 10],
        width: 2
      })
    })
  });
  return draw;
}

export class Draw {
  private _source = new ol.source.Vector();
  private _vector = getVector(this._source);
  private _draw: ol.interaction.Draw;
  private _sketch: any;
  private _measureTooltip: Overlay;
  private _helpTooltip: Overlay;
  private _pointerMoveHandler;
  constructor(
    private _darwType: string = '',
    private _callback: any,
    private _map: ol.Map,
    private _strokeColor?: string,
    private _fillColor?: string,
  ) { this._init(); }

  private _init() { this._addInteraction(); }
  private _addInteraction(): void {
    this._pointerMoveHandler = evt => {
      if (evt.dragging) { return; }
      let helpMsg = 'ç¹å»ç»å¶å¾å½¢';
      if (this._sketch) { helpMsg = 'åå»ç»§ç»­ç»å¶ï¼åå»ç»ææµé'; }
      this._helpTooltip.getDom().innerHTML = helpMsg;
      this._helpTooltip.setPosition(evt.coordinate);
    };
    this._map.addLayer(this._vector);
    this._map.on('pointermove', this._pointerMoveHandler);
    this._draw = addInteraction(this._darwType, this._source, this._fillColor, this._strokeColor);
    this._map.addInteraction(this._draw);
    this._createMarker();
    this._drawBinDrawstart();
    this._drawBinDrawend();
  }
  private _createMarker() {
    this._measureTooltip = new MeasureTooltip();
    this._measureTooltip.setOffset([0, -30]);
    this._map.addOverlay(this._measureTooltip.getMarker());
    this._helpTooltip = new HelpTooltip();
    this._helpTooltip.setOffset([10, 0]);
    this._map.addOverlay(this._helpTooltip.getMarker());
  }

  private _drawBinDrawstart() {
    this._draw.once('drawstart', evt => {
      this._sketch = evt.feature;
      let tooltipCoord = evt.coordinate;
      this._sketch.getGeometry().on('change', e => {
        const geom = e.target;
        if (geom instanceof ol.geom.Polygon) {
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof ol.geom.LineString) {
          tooltipCoord = geom.getLastCoordinate();
        }
        this._measureTooltip.getDom().innerHTML = _arr[this._darwType](geom);
        this._measureTooltip.setPosition(tooltipCoord);
      });
    }, this);
  }

  private _drawBinDrawend() {
    this._draw.once('drawend', e => {
      this._map.removeInteraction(this._draw);
      this._measureTooltip.getDom().appendChild(createSpan(this));
      this._map.un('pointermove', this._pointerMoveHandler);
      this._map.removeOverlay(this._helpTooltip.getMarker());
      this._helpTooltip = null;
      this._draw = null;
      this._sketch = null;
      this._callback(e);
    }, this);
  }

  public _clear() {
    this._map.removeLayer(this._vector);
    this._map.removeOverlay(this._measureTooltip.getMarker());
    this._measureTooltip = null;
    this._vector = null;
    this._source = null;
  }

}

export class Polygon {
  private _source = new ol.source.Vector();
  private _vector = getVector(this._source);
  private _draw: ol.interaction.Draw;
  private _sketch: any;
  private _helpTooltip: Overlay;
  private _pointerMoveHandler;
  constructor(
    private _darwType: string = '',
    private _callback: any,
    private _map: ol.Map,
    private _strokeColor?: string,
    private _fillColor?: string,
  ) { this._init(); }

  private _init() { this._addInteraction(); }
  private _addInteraction(): void {
    this._pointerMoveHandler = evt => {
      if (evt.dragging) { return; }
      let helpMsg = 'ç¹å»ç»å¶å¾å½¢';
      if (this._sketch) { helpMsg = 'åå»ç»§ç»­ç»å¶ï¼åå»ç»ææµé'; }
      this._helpTooltip.getDom().innerHTML = helpMsg;
      this._helpTooltip.setPosition(evt.coordinate);
    };
    this._map.addLayer(this._vector);
    this._map.on('pointermove', this._pointerMoveHandler);
    this._draw = addInteraction1(this._darwType, this._source, this._fillColor, this._strokeColor);
    this._map.addInteraction(this._draw);
    this._createMarker();
    this._drawBinDrawstart();
    this._drawBinDrawend();
  }
  private _createMarker() {
    this._helpTooltip = new HelpTooltip();
    this._helpTooltip.setOffset([10, 0]);
    this._map.addOverlay(this._helpTooltip.getMarker());
  }

  private _drawBinDrawstart() {
    this._draw.once('drawstart', evt => {
      this._sketch = evt.feature;
      let tooltipCoord = evt.coordinate;
      this._sketch.getGeometry().on('change', e => {
        const geom = e.target;
        if (geom instanceof ol.geom.Polygon) {
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof ol.geom.LineString) {
          tooltipCoord = geom.getLastCoordinate();
        }

      });
    }, this);
  }

  private _drawBinDrawend() {
    this._draw.once('drawend', e => {
      this._map.removeInteraction(this._draw);
      this._map.un('pointermove', this._pointerMoveHandler);
      this._map.removeOverlay(this._helpTooltip.getMarker());
      this._helpTooltip = null;
      this._draw = null;
      this._sketch = null;
      this._callback(e);
      this._clear();
    }, this);
  }

  public _clear() {
    this._map.removeLayer(this._vector);
    this._vector = null;
    this._source = null;
  }

}
